/*
 * action types
 */
export const APPLICATION_STARTS = 'APPLICATION_STARTS'

/*
 * action creators
 */
export const applicationStarts = (state) => {
  return dispatch => {
    dispatch({ type: APPLICATION_STARTS})
  }
}
